<template>
  <v-footer app height="40" flat border>
    <div class="d-flex justify-center align-center text-grey-darken-1" style="width: 100%; height: 100%;">
      GAVI Info
    </div>
  </v-footer>
</template>

<style scoped lang="sass">
  .social-link :deep(.v-icon)
    color: rgba(var(--v-theme-on-background), var(--v-disabled-opacity))
    text-decoration: none
    transition: .2s ease-in-out

    &:hover
      color: rgba(25, 118, 210, 1)
</style>
